import React from "react";
import { GlobalProvider } from "./global";
import { ApiProvider } from "./api";
import { ThemeProvider } from "./theme";
import { WalletProvider } from "../wallet";

const AppWebCheckinUserProvider: React.FC = ({ children }) => {
  return (
    <GlobalProvider>
      <ApiProvider>
        <ThemeProvider>
          <WalletProvider>
            {children}
          </WalletProvider>
        </ThemeProvider>
      </ApiProvider>
    </GlobalProvider>
  );
};

export default AppWebCheckinUserProvider;
